import React, { useState, useContext } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { useWallet } from 'use-wallet'
import { fromUtf8 } from 'web3-utils'
import ReactTooltip from 'react-tooltip'
import { ToastContainer, toast } from 'react-toastify'
import Container from 'components/Container'

import Modal from 'components/Modal'
import ModalTitle from 'components/ModalTitle'
import ModalContent from 'components/ModalContent'
import ModalActions from 'components/ModalActions'
import Button from 'components/Button'
import Input from 'components/Input'
import Spinner from 'react-svg-spinner'
import Label from 'components/Label'
import CardTitle from 'components/CardTitle'

import { AccountContext } from 'contexts/AccountProvider'
import CurrencySearch from 'components/CurrencySearch'
import Spacer from 'components/Spacer'
import Selector from 'components/Selector'

import { getTokenEtherFromWeiByAddress } from 'lottery/util'
import { viewTranscationURL } from 'lottery/constants'

const CreateNewPoolModal = ({ onDismiss, history }) => {
  const { poolsContract } = useContext(AccountContext)
  const { account } = useWallet()
  const [rewardToken, setRewardToken] = useState(null)
  const [rewardAmount, setRewardAmount] = useState(1)
  const [totalTickets, setTotalTickets] = useState(100)
  const [poolName, setPoolName] = useState('')
  const [weight, setWeight] = useState(100)
  const [openMenu, setOpenMenu] = useState(false)
  const [errMessage, setErrMessage] = useState()
  const [loading, setLoading] = useState(false)
  const [hashLink, setHashLink] = useState('')

  const handleCreateNewPool = async () => {
    if (isNaN(rewardAmount)) {
      setErrMessage('RewardToken should be number')
      return
    }

    if (isNaN(weight)) {
      setErrMessage('Weight should be number')
      return
    }

    if (!rewardToken) {
      setErrMessage('You should select token')
      return
    }

    if (totalTickets < 100) {
      setErrMessage('total tickets should be at least 100')
      return
    }

    if (weight < 100) {
      setErrMessage('weight should be at least 100')
      return
    }
    const transectionSuccess = () => {
      return (
        <div>
          Your pool has been created successfully!{' '}
          <a href={hashLink} target="_blank">
            View Transaction
          </a>
        </div>
      )
    }
    setLoading(true)
    poolsContract.methods
      .openNewPool(
        rewardToken.address,
        getTokenEtherFromWeiByAddress(rewardToken, rewardAmount),
        BigNumber(1e18).times(Number(weight)).toFixed(0),
        totalTickets,
        0,
        fromUtf8(poolName)
      )
      .send({ from: account })
      .once('receipt', (receipt) => {
        setLoading(false)
        const pid = receipt.events.PoolNameChange.returnValues.poolId
        setHashLink(viewTranscationURL + receipt.transactionHash)
        toast(transectionSuccess)
        setTimeout(() => {
          onDismiss()
        }, 5000)
        history.push(`pools/${pid}`)
        //window.location.reload(false)
      })
  }

  const handleChangeAmount = (e) => setRewardAmount(e.target.value)
  const handleChangeWeight = (e) => setWeight(e.target.value)
  const handleChangeTickets = (e) => setTotalTickets(e.target.value)
  const handleChangePoolName = (e) => setPoolName(e.target.value)

  const handleOpenSelector = () => {
    setOpenMenu(true)
  }

  const handleCloseSelector = () => {
    setOpenMenu(false)
  }

  return (
    <Modal createPool={true}>
      {openMenu ? (
        <CurrencySearch
          selectedCurrency={rewardToken}
          onCurrencySelect={setRewardToken}
          handleBlack={handleCloseSelector}
        />
      ) : (
        <div>
          <ModalTitle text="Create New Pool" />
          <ModalContent>
            <StyledWrapper>
              <Input
                startAdornment="Pool Name"
                value={poolName}
                onChange={handleChangePoolName}
              />
              <Spacer />
              <Selector
                handleOpenMenu={handleOpenSelector}
                placeholder="Select Token"
                selectedOption={rewardToken}
                startAdornment="Token Type"
                tooltip="Select the ERC20 token of your reward. For example, <br/>
								if you selected DAI as token type and entered 1,000 as reward amount, <br/>
								the winner of the lottery will get 1,000 DAI."
              />
              <Spacer />
              <Input
                startAdornment="Reward Amount"
                value={rewardAmount}
                onChange={handleChangeAmount}
                tooltip="Specify the amount of your reward. For example,  <br/>
								if you selected DAI as token type and entered 1,000 as reward amount,  <br/>
								the winner of the lottery will get 1,000 DAI."
              />
              <Spacer />
              <Input
                startAdornment="Total Tickets"
                value={totalTickets}
                onChange={handleChangeTickets}
                tooltip="Determines the ticket price of the pool. Need to be at least 100.  <br/>
								For example, if the jackpot is 1,000 DAI and total tickets is 100,  <br/>
								each ticket will be priced at 10 DAI."
              />
              <Spacer />
              <Input
                startAdornment="Weight"
                value={weight}
                onChange={handleChangeWeight}
                tooltip="This is the cost in UBET you'll have to pay to create your own lottery pool.  <br/>
								We take any amount greater than 100 UBET. The higher your weight,  <br/>
								the higher your pool ranks on home page."
              />
            </StyledWrapper>
            <Spacer />
            {loading ? (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <Spinner />
                <Label size="12" text="Waiting for the transaction" />
              </div>
            ) : (
              <></>
            )}
            <StyledInfo>{errMessage}</StyledInfo>
          </ModalContent>
          <Container size="sm">
            <p>
              You Bet! provides the service that allows eligible entities to
              create their own raffles. It is such entity's own responsibility
              to know whether you are eligible to run it. Unfortunately, since
              our service is fully decentralized, the technology is not
              available for You Bet! to help you find out whether you are
              eligible. We are not responsible for pool owner's behavior.{' '}
            </p>
            <p>
              While we can't offer you legal advice, if you are a US resident,
              we highly recommend that you get familiar with
              <a href="https://chance2win.org/us-online-legal-raffle/">
                {' '}
                your local raffle regulations{' '}
              </a>
              before using our service.{' '}
            </p>
          </Container>

          <ModalActions>
            <Button text="Cancel" variant="secondary" onClick={onDismiss} />
            <Button
              text="Create"
              variant="secondary"
              onClick={handleCreateNewPool}
            />
          </ModalActions>
          <ToastContainer />
        </div>
      )}
      <ReactTooltip
        id="soclose"
        effect="solid"
        className="tooltip-class"
        delayHide={500}
        delayUpdate={500}
        place="right"
        type="dark"
      />
    </Modal>
  )
}

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 422px;
`

const StyledInfo = styled.h4`
  color: ${(props) => props.theme.color.primary.main};
  font-size: 12px;
  text-align: center;
  margin: 0;
`
const StyledShowLink = styled.div`
  color: ${(props) => props.theme.color.grey[600]};
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  padding: ${(props) => props.theme.spacing[4]}px;
  text-align: center;
`

export default CreateNewPoolModal
